import React from 'react';
import { type RouteObject } from 'react-router-dom';
import ShowroomPage from './components/pages/ShowroomPage';

const routes: RouteObject[] = [
  {
    index: true,
    element: <ShowroomPage />,
  },
];

export default routes;
